import type GeneralSvgProps from "@/utils/types/sgv/general-svg-props.ts"

export const AddChatIcon: React.FC<GeneralSvgProps> = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12V18.3636C22 19.4219 22 19.951 21.8424 20.3736C21.589 21.0531 21.0531 21.589 20.3736 21.8424C19.951 22 19.4219 22 18.3636 22H12C6.47715 22 2 17.5229 2 12Z"
        stroke="currentColor"
      />
      <path
        d="M8.25 12H15.75"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 8.25V15.75"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
